export default {
    list: [{
            id: 1,
            title: 'components.chapters.3',
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/chapter3.jpg',
            link: process.env.MIX_CHAPTER_3,
        },
        {
            id: 2,
            title: 'components.chapters.4',
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/chapter4.png',
            link: process.env.MIX_CHAPTER_4,
        },
        {
            id: 3,
            title: 'components.chapters.releases.2019',
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/chapter4-scaled.jpg',
            link: process.env.MIX_RELEASES_2019,
        },
        {
            id: 4,
            title: 'components.chapters.releases.2020',
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/3years-ani.png',
            link: process.env.MIX_RELEASES_2020,
        },
        {
            id: 5,
            title: 'components.chapters.5',
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/chapter5.jpg',
            link: process.env.MIX_CHAPTER_5,
        },
        {
            id: 6,
            title: 'components.chapters.5part2',
            img: 'https://gm.goz.fun/wp-content/uploads/2023/10/chapter-5-part-2-cover-scaled.jpg',
            link: process.env.MIX_CHAPTER_5_PART_2,
        }
    ]
}
